import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethodsHotelNumber/FilterAttributeMethodsHotelNumber';
import distanceLiftData from './dataDistanceLift';
import { type IDistanceLift } from '../types';

const DistanceLiftAttribute = new FilterAttributeMethods<IDistanceLift>(distanceLiftData, 'distanceLift').setFilterName(
  'Расстояние до подъёмника',
);

export default DistanceLiftAttribute;
